import PropTypes from 'prop-types';
import React from 'react';
import './StripeInput.css';

const StripeInput = ({
  type = 'text',
  value,
  onChange,
  placeholder,
  label,
  error,
  disabled = false,
  required = false,
  fullWidth = false,
  className = '',
  inputClassName = '',
  id: providedId,
  inputRef,
  ...props
}) => {
  const generatedId = React.useId();
  const id = providedId || generatedId;

  const containerClassNames = [
    'stripe-form-group',
    fullWidth && 'stripe-form-group-full-width',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const inputClassNames = [
    'stripe-form-input',
    error && 'stripe-form-input-error',
    inputClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClassNames}>
      {label && (
        <label htmlFor={id} className="stripe-form-label">
          {label}
          {required && <span className="stripe-required">*</span>}
        </label>
      )}
      <input
        id={id}
        ref={inputRef}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={inputClassNames}
        aria-describedby={error ? `${id}-error` : undefined}
        aria-invalid={error ? 'true' : undefined}
        {...props}
      />
      {error && (
        <span id={`${id}-error`} className="stripe-form-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

StripeInput.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  id: PropTypes.string,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
};

export default StripeInput;

